import React from 'react'
import { Tabs, Tab, Box, createTheme, Switch, IconButton, Divider, Modal } from '@mui/material';
import { useState } from 'react';
import { Button, Grid, Paper, Stack, TextField, Typography } from "@mui/material";
import applicant from '../../images/profilePhoto.png';
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import Edit from '../../images/Edit.svg'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AddIcon from '@mui/icons-material/Add';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { styled } from '@mui/system';
import Upload from '../../images/portfolio.svg'
import SearchIcon from '@mui/icons-material/Search';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InputStyle from '../../assets/InputStyle';
import ChangePassword from './SignUp Dialog/ChangePassword';

function EmailTemplate() {
    const [search, setSearch] = useState("");
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSubmit = () => {
        handleClose();
    };


    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        // Perform upload logic here
        console.log('Uploaded file:', file);
    };



    return (
        <Layout>
            <UserLayout userRole={"employer"} >
                <Grid container mt={8}>
                    <Grid item md={8}>
                        <Typography className="heading1bold">
                            Email Templates
                        </Typography>
                    </Grid>
                    <Grid item md={4}>
                        <TextField
                            sx={{
                                background: '#F8FAFF',
                                boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014',
                            }}
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </Grid>
                </Grid>

                <Grid container mt={8}>
                    <Grid item md={6} xs={12}>
                        <Paper sx={{
                            background: '#F8FAFF',
                            boxShadow: '0px 26.398801803588867px 52.797603607177734px -9.89954948425293px #3665D014',
                            px: 2,
                            py: 2,
                            border: '0.86px solid',
                            borderImageSource: 'linear-gradient(119.69deg, rgba(0, 92, 247, 0.3) 1.06%, rgba(139, 172, 248, 0.3) 99.89%)',
                            borderImageSlice: 1,
                            borderRadius: '12px',
                        }}>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>
                                <Typography className='text1Bold' >
                                    Email Template Name
                                </Typography>
                                <Box>
                                    <IconButton
                                        sx={{
                                            backgroundColor: 'white',
                                            borderRadius: '50%',
                                            padding: '5px',
                                            border: '1px solid #d2d2d2',
                                            mx: 2
                                        }}
                                        onClick={handleOpen}
                                    >
                                        <img src={Edit} alt="cover photo" width="25px" height="25px" />
                                    </IconButton>
                                    <IconButton
                                        style={{
                                            backgroundColor: 'red',
                                            borderRadius: '50%',
                                            padding: '5px',

                                        }}
                                    >
                                        <DeleteOutlineIcon sx={{ color: '#fff' }} />
                                    </IconButton>
                                </Box>
                            </Box>
                            <Typography className='text2Mid' >
                                Lorem ipsum dolor sit amet consectetur. Sit mattis nibh donec elementum pellentesque viverra lorem sit.
                                Interdum interdum mi netus porttitor et. Vestibulum in sit viverra bibendum.
                                Tincidunt nisl diam sodales proin. Ut faucibus nulla enim cras vel viverra.
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <Modal
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                        >
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    width: '80%', // Set a maximum width for the modal
                                    maxWidth: '600px', // Optional: Set a maximum width for larger screens
                                    padding: '2rem 2rem',
                                }}
                            >
                                {/* Modal Content */}
                                <Typography
                                    id="modal-title"
                                    className='subHeading1Bold'
                                    style={{ color: '#2544EE', textAlign: 'center', marginBottom: '1rem' }}
                                >
                                    Create New Email Template
                                </Typography>
                                <Divider sx={{ background: '#d2d2d2', height: '1px', my: 1 }} />
                                <Box px={3} py={2}>
                                    <InputStyle name="Email" topSpace={true}>
                                        <input
                                            type="text"
                                            placeholder="Enter Email Template Name"
                                            style={{ width: '100%' }}
                                        // value={email}
                                        // onChange={(e) => handleInputChange(e, setEmail)}
                                        />
                                    </InputStyle>

                                    <InputStyle name="Message" topSpace={true}>
                                        <textarea
                                            type="text"
                                            placeholder="Write Something Here..."
                                            style={{ width: '100%' }}
                                        // value={email}
                                        // onChange={(e) => handleInputChange(e, setEmail)}
                                        />
                                    </InputStyle>
                                    <Button variant="contained" className='filledButton' onClick={handleSubmit} sx={{ mt: 2, }}>
                                        Save
                                    </Button>
                                </Box>
                            </div>
                        </Modal>
                    </Grid>
                </Grid>
                {/* <ChangePassword open={open} setOpen={setOpen}/> */}

            </UserLayout>
        </Layout >

    )
}

export default EmailTemplate